import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 40a10 10 0 1 0 10 10 10 10 0 0 0-10-10m0 28a18 18 0 1 1 18-18 18 18 0 0 1-18 18m0-46c-28 0-40 28-40 28s12 28 40 28 40-28 40-28-12-28-40-28" />
  </svg>
);
const ForwardRef = forwardRef(SvgEye);
export default ForwardRef;
